module.exports = __webpack_public_path__ + "static/services-img7-b7965ee13ac76a5eb78d116ab6653228.png";